import axios from "axios";

export default {
    namespaced: true,

    state: {
        dialectSheetConstants: [],
        allDialectSheetConstantsFilters: {
            sort: "id",
            search: null,
            sortOrder: "desc",
            offset: 0,
            limit: 50,
        },
        totalCount: 0,
        filteredResultsCount: 0,
    },

    getters: {
        dialectSheetConstants(state) {
            return state.dialectSheetConstants;
        },
        totalCount(state) {
            return state.totalCount;
        },
        filteredResultsCount(state) {
            return state.filteredResultsCount;
        },
    },

    mutations: {
        SET_ALL_DIALECT_SHEET_CONSTANTS(state, dialectSheetConstants) {
            state.dialectSheetConstants = dialectSheetConstants;
        },
        SET_FILTERS(state, value) {
            state.allDialectSheetConstantsFilters = value;
        },
        SET_FILTERED_RESULTS_TOTAL_COUNT(state, count) {
            state.filteredResultsCount = count;
        },
    },

    actions: {
        async getAllDialectSheetConstants({ commit, state }) {
            return await axios
                .get("/api/get-all-dialect-sheet-constants", {
                    params: state.allDialectSheetConstantsFilters,
                })
                .then((response) => {
                    commit("SET_ALL_DIALECT_SHEET_CONSTANTS", response.data.dialect_sheet_constants);
                    commit(
                        "SET_FILTERED_RESULTS_TOTAL_COUNT",
                        response.data.filterd_results_count
                    );
                    return response;
                });
        },
        async getDialectSheetConstant({ commit }, id) {
            return await axios.get("/api/get-dialect-sheet-constant", {
                params: { id },
            });
        },
        async updateDialectSheetConstant({ commit }, payload) {
            await axios
                .post("/api/update-dialect-sheet-constant", payload)
                .then((response) => {});
        },
        async updateData({ dispatch }) {
            await dispatch("getAllDialectSheetConstants");
        },

        async fetchImages({ commit }, dialectSheetConstantId) {
            return await axios.get("/api/get-dialect-sheet-constant-images", {
                params: { dialect_sheet_constant_id: dialectSheetConstantId },
            });
        },
        async fetchAudioFiles({ commit }, dialectSheetConstantId) {
            return await axios.get("/api/get-dialect-sheet-constant-audio-files", {
                params: { dialect_sheet_constant_id: dialectSheetConstantId },
            });
        },
        async uploadImage({ commit }, formData) {
            return await axios.post("/api/create-dialect-sheet-constant-image", formData);
        },
        async deleteImage({ commit }, id) {
            return await axios.post("/api/delete-dialect-sheet-constant-image", { id });
        },
        async uploadAudioFile({ commit }, formData) {
            return await axios.post("/api/create-dialect-sheet-constant-audio-file", formData);
        },
        async updateAudioFileMeta({ commit }, payload) {
            return await axios.post("/api/update-dialect-sheet-constant-audio-file", payload);
        },
        async deleteAudioFile({ commit }, id) {
            return await axios.post("/api/delete-dialect-sheet-constant-audio-file", { id });
        },
        async fetchPdfFiles({ commit }, dialectSheetConstantId) {
            return await axios.get("/api/get-dialect-sheet-constant-pdf-files", {
                params: { dialect_sheet_constant_id: dialectSheetConstantId },
            });
        },
        async uploadPdfFile({ commit }, formData) {
            return await axios.post("/api/create-dialect-sheet-constant-pdf-file", formData);
        },
        async deletePdfFile({ commit }, id) {
            return await axios.post("/api/delete-dialect-sheet-constant-pdf-file", { id });
        },
    },
};
